import { render, staticRenderFns } from "./BlockDetailsModal.vue?vue&type=template&id=030e62d8&scoped=true"
import script from "./BlockDetailsModal.vue?vue&type=script&lang=js"
export * from "./BlockDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./BlockDetailsModal.vue?vue&type=style&index=0&id=030e62d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e62d8",
  null
  
)

export default component.exports